import { createAdConfig } from '~/utils/adUtil'

export const adConfig = {}

adConfig.AD_SIZES = {
  PC_ATF: [
    [468, 60],
    [640, 100],
    [320, 50],
    [320, 100],
    [728, 90]
  ],
  PC_BTF_1: [
    [1, 1],
    [320, 180],
    [320, 250],
    [300, 250],
    [336, 280],
    [320, 100],
    [200, 200],
    [320, 50]
  ],
  PC_BTF_2_LEFT: [
    [336, 280]
  ],
  PC_BTF_2_RIGHT: [
    [336, 280]
  ],
  PC_BTF_3: [
    [200, 200],
    [320, 100],
    [320, 50],
    [1, 1],
    [320, 180],
    [320, 250],
    [336, 280],
    [300, 250]
  ],
  PC_BTF_4_LEFT: [
    [336, 280]
  ],
  PC_BTF_4_RIGHT: [
    [336, 280]
  ],
  PC_BTF_5: [
    [468, 60],
    [640, 100],
    [320, 50],
    [320, 100],
    [728, 90]
  ],
  PC_BTM: [
    [200, 200],
    [320, 100],
    [120, 600],
    [320, 50],
    [336, 280],
    [320, 250],
    [320, 180],
    [160, 600],
    [300, 250],
    [300, 600],
    [1, 1]
  ],
  SP_ATF: [
    [320, 100],
    [320, 50]
  ],
  SP_BTF_1: [
    [300, 250],
    [336, 280],
    [200, 200],
    [320, 180],
    [320, 250],
    [320, 100],
    [1, 1],
    [320, 50]
  ],
  SP_BTF_1_SMALL_HEIGHT: [
    [320, 100],
    [320, 50]
  ],
  SP_BTF_2: [
    [200, 200],
    [320, 100],
    [320, 250],
    [336, 280],
    [320, 50],
    [1, 1],
    [300, 250],
    [320, 180]
  ],
  SP_BTF_3: [
    [300, 250],
    [320, 180],
    [200, 200],
    [320, 100],
    [320, 250],
    [320, 50],
    [336, 280]
  ],
  SP_BTF_4: [
    [200, 200],
    [320, 180],
    [320, 250],
    [336, 280],
    [300, 250],
    [320, 100],
    [320, 50]
  ],
  SP_BTF_4_SMALL_HEIGHT: [
    [320, 100],
    [320, 50]
  ],
  SP_BTF_5: [
    [336, 280],
    [200, 200],
    [320, 180],
    [320, 250],
    [300, 250],
    [320, 100],
    [320, 50]
  ],
  SP_BTM: [
    [320, 180],
    [320, 250],
    [336, 280],
    [320, 50],
    [320, 100],
    [200, 200],
    [300, 250]
  ],
  STICKY: [320, 50],
  PC_STICKY: [
    [970, 90],
    [640, 100],
    [640, 50],
    [950, 90],
    [728, 90],
    [950, 70]
  ]
}

adConfig.gpt_conf = [
  createAdConfig('Onebox_world_atf_pc', adConfig.AD_SIZES.PC_ATF, 'ads-atf', 'DATA', false, 'pc'),
  createAdConfig('Onebox_world_btf1_pc', adConfig.AD_SIZES.PC_BTF_1, 'ads-btf1-pc', 'DATA', false, 'pc'),
  createAdConfig('Onebox_world_btf2_pc', adConfig.AD_SIZES.PC_BTF_2_LEFT, 'ads-btf2-left-pc', 'DATA', true, 'pc'),
  createAdConfig('Onebox_world_btf2_pc_right', adConfig.AD_SIZES.PC_BTF_2_RIGHT, 'ads-btf2-right-pc', 'DATA', true, 'pc'),
  createAdConfig('Onebox_world_btf3_pc', adConfig.AD_SIZES.PC_BTF_3, 'ads-btf3-pc', 'DATA', false, 'pc'),
  createAdConfig('Onebox_world_btf4_pc', adConfig.AD_SIZES.PC_BTF_4_LEFT, 'ads-btf4-left-pc', 'DATA', true, 'pc'),
  createAdConfig('Onebox_world_btf4_pc_right', adConfig.AD_SIZES.PC_BTF_4_RIGHT, 'ads-btf4-right-pc', 'DATA', true, 'pc'),
  createAdConfig('Onebox_world_btf5_pc', adConfig.AD_SIZES.PC_BTF_5, 'ads-btf5-pc', 'DATA', false, 'pc'),
  createAdConfig('Onebox_world_btm_pc', adConfig.AD_SIZES.PC_BTM, 'ads-btm', 'DATA', false, 'pc'),

  createAdConfig('Onebox_world_atf_sp', adConfig.AD_SIZES.SP_ATF, 'ads-atf', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf1_sp', adConfig.AD_SIZES.SP_BTF_1, 'ads-btf1-sp', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf1_sp', adConfig.AD_SIZES.SP_BTF_1_SMALL_HEIGHT, 'ads-btf1-sp-small-height', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf2_sp', adConfig.AD_SIZES.SP_BTF_2, 'ads-btf2-sp', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf3_sp', adConfig.AD_SIZES.SP_BTF_3, 'ads-btf3-sp', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf4_sp', adConfig.AD_SIZES.SP_BTF_4, 'ads-btf4-sp', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf4_sp', adConfig.AD_SIZES.SP_BTF_4_SMALL_HEIGHT, 'ads-btf4-sp-small-height', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btf5_sp', adConfig.AD_SIZES.SP_BTF_5, 'ads-btf5-sp', 'DATA', false, 'sp'),
  createAdConfig('Onebox_world_btm_sp', adConfig.AD_SIZES.SP_BTM, 'ads-btm', 'DATA', false, 'sp'),
  createAdConfig('Onebox_sticky_ad', adConfig.AD_SIZES.STICKY, 'div-gpt-ad-sticky', 'DATA', true, 'sp', true),
  createAdConfig('Onebox_stickyad_pc', adConfig.AD_SIZES.PC_STICKY, 'div-gpt-ad-1666850974098-0', 'DATA', true, 'pc', true)
]
